export enum OrderPages {
  WAITING_FOR_REVIEW,
  WAITING_FOR_FINAL_ORDER,
  WAITING_FOR_PAYMENT,
  WAITING_FOR_SCHEDULE,
  FINISHED
}
